const NotFound404 = () => <div>Page not Found</div>;

export default NotFound404;
